import React, { useState } from "react";

const CustomerVoices = () => {
  return (
    <div className="bg-gradient-to-r from-red-600 to-blue-700 py-16 px-4 md:px-12">
      {/* Header */}
      <div className="text-center text-white mb-12">
        <h2 className="text-3xl md:text-4xl font-bold mb-2">Customer voices:</h2>
        <p className="text-gray-200 mb-4">What they're saying about us...</p>
        <a href="#" className="text-yellow-300 hover:underline">
          Read more Academy testimonials ›
        </a>
      </div>

      {/* Cards */}
      <div className="grid gap-8 md:grid-cols-2">
        <div className="bg-black/50 p-6 rounded-xl shadow-lg flex flex-col justify-between">
          <p className="text-white mb-4">
            <strong>NVISO</strong> stays threat-ready with HTB’s enterprise platform.
          </p>
          <div className="flex items-center justify-between">
            <span className="text-green-400">25 Dedicated Labs / 5 Academy Slots</span>
           
            <button className="bg-green-400 text-black rounded-full w-10 h-10 flex items-center justify-center text-lg hover:scale-110 transition-transform">
              →
            </button>
          </div>
        </div>

        <div className="bg-black/50 p-6 rounded-xl shadow-lg flex flex-col justify-between">
          <p className="text-white mb-4">
            <strong>Sheffield Hallam University</strong> teaches the next generation of cyber professionals.
          </p>
          <div className="flex items-center justify-between">
            <span className="text-green-400">15 Professional Labs / 10 Academy Slots</span>
            
            <button className="bg-green-400 text-black rounded-full w-10 h-10 flex items-center justify-center text-lg hover:scale-110 transition-transform">
              →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const GetStartedForm = () => {
  const [form, setForm] = useState({
    email: "",
    firstName: "",
    lastName: "",
    company: "",
    teamSize: "",
    organization: "",
    country: "",
    help: "",
    message: "",
  });

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", form);
    alert("Form submitted!");
  };

  return (
    <div className="bg-gradient-to-r from-red-600 to-blue-700 py-16 px-4 md:px-12">
      {/* Header */}
      <div className="text-center text-white mb-12">
        <h2 className="text-3xl md:text-4xl font-bold mb-2">Get Started</h2>
        <p className="text-gray-200">How to get your IT team up and running in 3 easy steps.</p>
      </div>

      {/* Steps */}
      <div className="grid md:grid-cols-3 gap-6 mb-12 text-white">
        <div className="bg-black/50 p-6 rounded-xl shadow-lg text-center">
          <h3 className="font-bold text-xl mb-2">Step 1</h3>
          <p>Let’s meet and understand your needs. Submit the form.</p>
        </div>
        <div className="bg-black/50 p-6 rounded-xl shadow-lg text-center">
          <h3 className="font-bold text-xl mb-2">Step 2</h3>
          <p>Contract details and admin dashboard access.</p>
        </div>
        <div className="bg-black/50 p-6 rounded-xl shadow-lg text-center">
          <h3 className="font-bold text-xl mb-2">Step 3</h3>
          <p>Invite employees and let the training begin.</p>
        </div>
      </div>

      {/* Form */}
      <form onSubmit={handleSubmit} className="bg-black/50 p-8 rounded-xl shadow-lg max-w-4xl mx-auto text-white">
        <div className="grid md:grid-cols-2 gap-4 mb-4">
          <input
            type="email"
            name="email"
            placeholder="Business email*"
            value={form.email}
            onChange={handleChange}
            required
            className="p-3 rounded bg-gray-800 placeholder-gray-400"
          />
          <input
            type="text"
            name="firstName"
            placeholder="First name*"
            value={form.firstName}
            onChange={handleChange}
            required
            className="p-3 rounded bg-gray-800 placeholder-gray-400"
          />
          <input
            type="text"
            name="lastName"
            placeholder="Last name*"
            value={form.lastName}
            onChange={handleChange}
            required
            className="p-3 rounded bg-gray-800 placeholder-gray-400"
          />
          <input
            type="text"
            name="company"
            placeholder="Company*"
            value={form.company}
            onChange={handleChange}
            required
            className="p-3 rounded bg-gray-800 placeholder-gray-400"
          />
          <input
            type="text"
            name="teamSize"
            placeholder="Security / IT team size*"
            value={form.teamSize}
            onChange={handleChange}
            required
            className="p-3 rounded bg-gray-800 placeholder-gray-400"
          />
          <input
            type="text"
            name="organization"
            placeholder="Organization type*"
            value={form.organization}
            onChange={handleChange}
            required
            className="p-3 rounded bg-gray-800 placeholder-gray-400"
          />
          <input
            type="text"
            name="country"
            placeholder="Country*"
            value={form.country}
            onChange={handleChange}
            required
            className="p-3 rounded bg-gray-800 placeholder-gray-400"
          />
          <input
            type="text"
            name="help"
            placeholder="I'm looking for help with..."
            value={form.help}
            onChange={handleChange}
            className="p-3 rounded bg-gray-800 placeholder-gray-400"
          />
        </div>

        <textarea
          name="message"
          placeholder="Tell us more about your project, needs, and timeline."
          rows="4"
          value={form.message}
          onChange={handleChange}
          className="w-full p-3 rounded bg-gray-800 placeholder-gray-400 mb-4"
        />

        <button
          type="submit"
          className="bg-green-400 text-black font-bold px-6 py-3 rounded hover:scale-105 transition-transform"
        >
          Submit
        </button>
      </form>
    </div>
  );
};

export default function Pagess() {
  return (
    <div>
      <CustomerVoices />
      <GetStartedForm />
    </div>
  );
}